// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_user.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppUserResponsiblePartyService } from "./app_user";
import type { AppUserResponsiblePartyServiceResetRequest } from "./app_user";
import type { AppUserResponsiblePartyServiceSetRequest } from "./app_user";
import { AppUserCredentialService } from "./app_user";
import type { AppUserCredentialServiceDeleteResponse } from "./app_user";
import type { AppUserCredentialServiceDeleteRequest } from "./app_user";
import type { SearchAppUserHasAppUserCredentialsResponse } from "./app_user";
import type { SearchAppUserHasAppUserCredentialsRequest } from "./app_user";
import type { SearchAppUserCredentialsByVaultIDResponse } from "./app_user";
import type { SearchAppUserCredentialsByVaultIDRequest } from "./app_user";
import type { AppUserCredentialServiceSearchTermsResponse } from "./app_user";
import type { AppUserCredentialServiceSearchTermsRequest } from "./app_user";
import type { ListAppUserCredentialsWithVaultResponse } from "./app_user";
import type { ListAppUserCredentialsWithVaultRequest } from "./app_user";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppUserService } from "./app_user";
import type { CountAppUsersByAppsResponse } from "./app_user";
import type { CountAppUsersByAppsRequest } from "./app_user";
import type { SearchOrphanedAccountsResponse } from "./app_user";
import type { SearchOrphanedAccountsRequest } from "./app_user";
import type { TotalCountOrphanedAccountsResponse } from "./app_user";
import type { TotalCountOrphanedAccountsRequest } from "./app_user";
import type { CountHighRiskUsersAndGrantsResponse } from "./app_user";
import type { CountHighRiskUsersAndGrantsRequest } from "./app_user";
import type { HighRiskUsersAndGrantsResponse } from "./app_user";
import type { HighRiskUsersAndGrantsRequest } from "./app_user";
import type { AppUsersWithoutResponsiblePartyRequest } from "./app_user";
import type { CountAppUsersWithoutResponsiblePartyResponse } from "./app_user";
import type { CountAppUsersWithoutResponsiblePartyRequest } from "./app_user";
import type { AppWithUserCountRollupResponse } from "./app_user";
import type { AppWithUserCountRollupRequest } from "./app_user";
import type { GetUserSearchTermsResponse } from "./app_user";
import type { GetUserSearchTermsRequest } from "./app_user";
import type { AppUserServiceSearchCountsByTypeResponse } from "./app_user";
import type { AppUserServiceSearchCountsByTypeRequest } from "./app_user";
import type { AppUserServiceSearchCountResponse } from "./app_user";
import type { AppUserServiceSearchCountRequest } from "./app_user";
import type { AppUserServiceSearchWithAlertsResponse } from "./app_user";
import type { AppUserServiceSearchWithAlertsRequest } from "./app_user";
import type { AppUserServiceSearchResponse } from "./app_user";
import type { AppUserServiceSearchRequest } from "./app_user";
import type { Empty } from "../../../../google/protobuf/empty";
import type { AppUserServiceDeleteRequest } from "./app_user";
import type { AppUserServiceUpdateResponse } from "./app_user";
import type { AppUserServiceUpdateRequest } from "./app_user";
import type { AppUserServiceCreateRequest } from "./app_user";
import type { AppUserServiceListCredentialsResponse } from "./app_user";
import type { AppUserServiceListCredentialsRequest } from "./app_user";
import type { AppUsersForUserServiceListResponse } from "./app_user";
import type { AppUsersForUserServiceListRequest } from "./app_user";
import type { AppUserServiceListResponse } from "./app_user";
import type { AppUserServiceListRequest } from "./app_user";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AppUserServiceGetResponse } from "./app_user";
import type { AppUserServiceGetRequest } from "./app_user";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppUserService
 */
export interface IAppUserServiceClient {
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AppUserServiceGetRequest, options?: RpcOptions): UnaryCall<AppUserServiceGetRequest, AppUserServiceGetResponse>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AppUserServiceListRequest, options?: RpcOptions): UnaryCall<AppUserServiceListRequest, AppUserServiceListResponse>;
    /**
     * @generated from protobuf rpc: ListAppUsersForUser
     */
    listAppUsersForUser(input: AppUsersForUserServiceListRequest, options?: RpcOptions): UnaryCall<AppUsersForUserServiceListRequest, AppUsersForUserServiceListResponse>;
    /**
     * @generated from protobuf rpc: ListAppUserCredentials
     */
    listAppUserCredentials(input: AppUserServiceListCredentialsRequest, options?: RpcOptions): UnaryCall<AppUserServiceListCredentialsRequest, AppUserServiceListCredentialsResponse>;
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AppUserServiceCreateRequest, options?: RpcOptions): UnaryCall<AppUserServiceCreateRequest, AppUserServiceGetResponse>;
    /**
     * Update an app user by ID. Only the fields specified in the update mask are updated.
     * Currently, only the appUserType, and identityUserId fields can be updated.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: AppUserServiceUpdateRequest, options?: RpcOptions): UnaryCall<AppUserServiceUpdateRequest, AppUserServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AppUserServiceDeleteRequest, options?: RpcOptions): UnaryCall<AppUserServiceDeleteRequest, Empty>;
    /**
     * Search app users based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: AppUserServiceSearchRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchRequest, AppUserServiceSearchResponse>;
    /**
     * @generated from protobuf rpc: SearchWithAlerts
     */
    searchWithAlerts(input: AppUserServiceSearchWithAlertsRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchWithAlertsRequest, AppUserServiceSearchWithAlertsResponse>;
    /**
     * @generated from protobuf rpc: SearchCount
     */
    searchCount(input: AppUserServiceSearchCountRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchCountRequest, AppUserServiceSearchCountResponse>;
    /**
     * @generated from protobuf rpc: SearchCountsByType
     */
    searchCountsByType(input: AppUserServiceSearchCountsByTypeRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchCountsByTypeRequest, AppUserServiceSearchCountsByTypeResponse>;
    /**
     * @generated from protobuf rpc: GetUserSearchTerms
     */
    getUserSearchTerms(input: GetUserSearchTermsRequest, options?: RpcOptions): UnaryCall<GetUserSearchTermsRequest, GetUserSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: CountOrphanedAccounts
     */
    countOrphanedAccounts(input: AppWithUserCountRollupRequest, options?: RpcOptions): UnaryCall<AppWithUserCountRollupRequest, AppWithUserCountRollupResponse>;
    /**
     * @generated from protobuf rpc: CountAppUsersWithoutResponsibleParty
     */
    countAppUsersWithoutResponsibleParty(input: CountAppUsersWithoutResponsiblePartyRequest, options?: RpcOptions): UnaryCall<CountAppUsersWithoutResponsiblePartyRequest, CountAppUsersWithoutResponsiblePartyResponse>;
    /**
     * @generated from protobuf rpc: AppUsersWithoutResponsibleParty
     */
    appUsersWithoutResponsibleParty(input: AppUsersWithoutResponsiblePartyRequest, options?: RpcOptions): UnaryCall<AppUsersWithoutResponsiblePartyRequest, AppUserServiceListResponse>;
    /**
     * @generated from protobuf rpc: HighRiskUsersAndGrants
     */
    highRiskUsersAndGrants(input: HighRiskUsersAndGrantsRequest, options?: RpcOptions): UnaryCall<HighRiskUsersAndGrantsRequest, HighRiskUsersAndGrantsResponse>;
    /**
     * @generated from protobuf rpc: CountHighRiskUsersAndGrants
     */
    countHighRiskUsersAndGrants(input: CountHighRiskUsersAndGrantsRequest, options?: RpcOptions): UnaryCall<CountHighRiskUsersAndGrantsRequest, CountHighRiskUsersAndGrantsResponse>;
    /**
     * @generated from protobuf rpc: TotalCountOrphanedAccounts
     */
    totalCountOrphanedAccounts(input: TotalCountOrphanedAccountsRequest, options?: RpcOptions): UnaryCall<TotalCountOrphanedAccountsRequest, TotalCountOrphanedAccountsResponse>;
    /**
     * @generated from protobuf rpc: SearchOrphanedAccounts
     */
    searchOrphanedAccounts(input: SearchOrphanedAccountsRequest, options?: RpcOptions): UnaryCall<SearchOrphanedAccountsRequest, SearchOrphanedAccountsResponse>;
    /**
     * @generated from protobuf rpc: CountAppUsersByApps
     */
    countAppUsersByApps(input: CountAppUsersByAppsRequest, options?: RpcOptions): UnaryCall<CountAppUsersByAppsRequest, CountAppUsersByAppsResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppUserService
 */
export class AppUserServiceClient implements IAppUserServiceClient, ServiceInfo {
    typeName = AppUserService.typeName;
    methods = AppUserService.methods;
    options = AppUserService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: AppUserServiceGetRequest, options?: RpcOptions): UnaryCall<AppUserServiceGetRequest, AppUserServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceGetRequest, AppUserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AppUserServiceListRequest, options?: RpcOptions): UnaryCall<AppUserServiceListRequest, AppUserServiceListResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceListRequest, AppUserServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAppUsersForUser
     */
    listAppUsersForUser(input: AppUsersForUserServiceListRequest, options?: RpcOptions): UnaryCall<AppUsersForUserServiceListRequest, AppUsersForUserServiceListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUsersForUserServiceListRequest, AppUsersForUserServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAppUserCredentials
     */
    listAppUserCredentials(input: AppUserServiceListCredentialsRequest, options?: RpcOptions): UnaryCall<AppUserServiceListCredentialsRequest, AppUserServiceListCredentialsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceListCredentialsRequest, AppUserServiceListCredentialsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AppUserServiceCreateRequest, options?: RpcOptions): UnaryCall<AppUserServiceCreateRequest, AppUserServiceGetResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceCreateRequest, AppUserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an app user by ID. Only the fields specified in the update mask are updated.
     * Currently, only the appUserType, and identityUserId fields can be updated.
     *
     * @generated from protobuf rpc: Update
     */
    update(input: AppUserServiceUpdateRequest, options?: RpcOptions): UnaryCall<AppUserServiceUpdateRequest, AppUserServiceUpdateResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceUpdateRequest, AppUserServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AppUserServiceDeleteRequest, options?: RpcOptions): UnaryCall<AppUserServiceDeleteRequest, Empty> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceDeleteRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * Search app users based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: AppUserServiceSearchRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchRequest, AppUserServiceSearchResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceSearchRequest, AppUserServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchWithAlerts
     */
    searchWithAlerts(input: AppUserServiceSearchWithAlertsRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchWithAlertsRequest, AppUserServiceSearchWithAlertsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceSearchWithAlertsRequest, AppUserServiceSearchWithAlertsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCount
     */
    searchCount(input: AppUserServiceSearchCountRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchCountRequest, AppUserServiceSearchCountResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceSearchCountRequest, AppUserServiceSearchCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchCountsByType
     */
    searchCountsByType(input: AppUserServiceSearchCountsByTypeRequest, options?: RpcOptions): UnaryCall<AppUserServiceSearchCountsByTypeRequest, AppUserServiceSearchCountsByTypeResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserServiceSearchCountsByTypeRequest, AppUserServiceSearchCountsByTypeResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetUserSearchTerms
     */
    getUserSearchTerms(input: GetUserSearchTermsRequest, options?: RpcOptions): UnaryCall<GetUserSearchTermsRequest, GetUserSearchTermsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUserSearchTermsRequest, GetUserSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountOrphanedAccounts
     */
    countOrphanedAccounts(input: AppWithUserCountRollupRequest, options?: RpcOptions): UnaryCall<AppWithUserCountRollupRequest, AppWithUserCountRollupResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppWithUserCountRollupRequest, AppWithUserCountRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountAppUsersWithoutResponsibleParty
     */
    countAppUsersWithoutResponsibleParty(input: CountAppUsersWithoutResponsiblePartyRequest, options?: RpcOptions): UnaryCall<CountAppUsersWithoutResponsiblePartyRequest, CountAppUsersWithoutResponsiblePartyResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountAppUsersWithoutResponsiblePartyRequest, CountAppUsersWithoutResponsiblePartyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AppUsersWithoutResponsibleParty
     */
    appUsersWithoutResponsibleParty(input: AppUsersWithoutResponsiblePartyRequest, options?: RpcOptions): UnaryCall<AppUsersWithoutResponsiblePartyRequest, AppUserServiceListResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUsersWithoutResponsiblePartyRequest, AppUserServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: HighRiskUsersAndGrants
     */
    highRiskUsersAndGrants(input: HighRiskUsersAndGrantsRequest, options?: RpcOptions): UnaryCall<HighRiskUsersAndGrantsRequest, HighRiskUsersAndGrantsResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<HighRiskUsersAndGrantsRequest, HighRiskUsersAndGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountHighRiskUsersAndGrants
     */
    countHighRiskUsersAndGrants(input: CountHighRiskUsersAndGrantsRequest, options?: RpcOptions): UnaryCall<CountHighRiskUsersAndGrantsRequest, CountHighRiskUsersAndGrantsResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountHighRiskUsersAndGrantsRequest, CountHighRiskUsersAndGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TotalCountOrphanedAccounts
     */
    totalCountOrphanedAccounts(input: TotalCountOrphanedAccountsRequest, options?: RpcOptions): UnaryCall<TotalCountOrphanedAccountsRequest, TotalCountOrphanedAccountsResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<TotalCountOrphanedAccountsRequest, TotalCountOrphanedAccountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchOrphanedAccounts
     */
    searchOrphanedAccounts(input: SearchOrphanedAccountsRequest, options?: RpcOptions): UnaryCall<SearchOrphanedAccountsRequest, SearchOrphanedAccountsResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchOrphanedAccountsRequest, SearchOrphanedAccountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountAppUsersByApps
     */
    countAppUsersByApps(input: CountAppUsersByAppsRequest, options?: RpcOptions): UnaryCall<CountAppUsersByAppsRequest, CountAppUsersByAppsResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountAppUsersByAppsRequest, CountAppUsersByAppsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppUserCredentialService
 */
export interface IAppUserCredentialServiceClient {
    /**
     * @generated from protobuf rpc: ListAppUserCredentialsWithVault
     */
    listAppUserCredentialsWithVault(input: ListAppUserCredentialsWithVaultRequest, options?: RpcOptions): UnaryCall<ListAppUserCredentialsWithVaultRequest, ListAppUserCredentialsWithVaultResponse>;
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: AppUserCredentialServiceSearchTermsRequest, options?: RpcOptions): UnaryCall<AppUserCredentialServiceSearchTermsRequest, AppUserCredentialServiceSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: SearchAppUserCredentialsByVaultID
     */
    searchAppUserCredentialsByVaultID(input: SearchAppUserCredentialsByVaultIDRequest, options?: RpcOptions): UnaryCall<SearchAppUserCredentialsByVaultIDRequest, SearchAppUserCredentialsByVaultIDResponse>;
    /**
     * @generated from protobuf rpc: SearchAppUserHasAppUserCredentials
     */
    searchAppUserHasAppUserCredentials(input: SearchAppUserHasAppUserCredentialsRequest, options?: RpcOptions): UnaryCall<SearchAppUserHasAppUserCredentialsRequest, SearchAppUserHasAppUserCredentialsResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AppUserCredentialServiceDeleteRequest, options?: RpcOptions): UnaryCall<AppUserCredentialServiceDeleteRequest, AppUserCredentialServiceDeleteResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppUserCredentialService
 */
export class AppUserCredentialServiceClient implements IAppUserCredentialServiceClient, ServiceInfo {
    typeName = AppUserCredentialService.typeName;
    methods = AppUserCredentialService.methods;
    options = AppUserCredentialService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListAppUserCredentialsWithVault
     */
    listAppUserCredentialsWithVault(input: ListAppUserCredentialsWithVaultRequest, options?: RpcOptions): UnaryCall<ListAppUserCredentialsWithVaultRequest, ListAppUserCredentialsWithVaultResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppUserCredentialsWithVaultRequest, ListAppUserCredentialsWithVaultResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: AppUserCredentialServiceSearchTermsRequest, options?: RpcOptions): UnaryCall<AppUserCredentialServiceSearchTermsRequest, AppUserCredentialServiceSearchTermsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserCredentialServiceSearchTermsRequest, AppUserCredentialServiceSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppUserCredentialsByVaultID
     */
    searchAppUserCredentialsByVaultID(input: SearchAppUserCredentialsByVaultIDRequest, options?: RpcOptions): UnaryCall<SearchAppUserCredentialsByVaultIDRequest, SearchAppUserCredentialsByVaultIDResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppUserCredentialsByVaultIDRequest, SearchAppUserCredentialsByVaultIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppUserHasAppUserCredentials
     */
    searchAppUserHasAppUserCredentials(input: SearchAppUserHasAppUserCredentialsRequest, options?: RpcOptions): UnaryCall<SearchAppUserHasAppUserCredentialsRequest, SearchAppUserHasAppUserCredentialsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppUserHasAppUserCredentialsRequest, SearchAppUserHasAppUserCredentialsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AppUserCredentialServiceDeleteRequest, options?: RpcOptions): UnaryCall<AppUserCredentialServiceDeleteRequest, AppUserCredentialServiceDeleteResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserCredentialServiceDeleteRequest, AppUserCredentialServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppUserResponsiblePartyService
 */
export interface IAppUserResponsiblePartyServiceClient {
    /**
     * @generated from protobuf rpc: SetIdentity
     */
    setIdentity(input: AppUserResponsiblePartyServiceSetRequest, options?: RpcOptions): UnaryCall<AppUserResponsiblePartyServiceSetRequest, AppUserServiceGetResponse>;
    /**
     * @generated from protobuf rpc: ResetIdentity
     */
    resetIdentity(input: AppUserResponsiblePartyServiceResetRequest, options?: RpcOptions): UnaryCall<AppUserResponsiblePartyServiceResetRequest, AppUserServiceGetResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppUserResponsiblePartyService
 */
export class AppUserResponsiblePartyServiceClient implements IAppUserResponsiblePartyServiceClient, ServiceInfo {
    typeName = AppUserResponsiblePartyService.typeName;
    methods = AppUserResponsiblePartyService.methods;
    options = AppUserResponsiblePartyService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SetIdentity
     */
    setIdentity(input: AppUserResponsiblePartyServiceSetRequest, options?: RpcOptions): UnaryCall<AppUserResponsiblePartyServiceSetRequest, AppUserServiceGetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserResponsiblePartyServiceSetRequest, AppUserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ResetIdentity
     */
    resetIdentity(input: AppUserResponsiblePartyServiceResetRequest, options?: RpcOptions): UnaryCall<AppUserResponsiblePartyServiceResetRequest, AppUserServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppUserResponsiblePartyServiceResetRequest, AppUserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
}
